import { render } from "./BrandedTextElementProduction.vue.js?vue&type=template&id=50d98aee&scoped=true!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BrandedTextElementProduction.vue?vue&type=template&id=50d98aee&scoped=true"
import script from "./BrandedTextElementProduction.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BrandedTextElementProduction.vue?vue&type=script&lang=js"
export * from "./BrandedTextElementProduction.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BrandedTextElementProduction.vue?vue&type=script&lang=js"

import "./BrandedTextElementProduction.vue.scss?vue&type=style&index=0&id=50d98aee&lang=scss&scoped=true!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BrandedTextElementProduction.vue?vue&type=style&index=0&id=50d98aee&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50d98aee"],['__file',"src/SharedWeb/scripts/dynamic-component-editor/standard-elements/text-element/BrandedTextElementProduction.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "50d98aee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('50d98aee', __exports__)) {
    api.reload('50d98aee', __exports__)
  }
  
  module.hot.accept("./BrandedTextElementProduction.vue.js?vue&type=template&id=50d98aee&scoped=true!=!../../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./BrandedTextElementProduction.vue?vue&type=template&id=50d98aee&scoped=true", () => {
    api.rerender('50d98aee', render)
  })

}


export default __exports__